import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { IBOMParameters, SalesService } from '@shared/services/sales.service';
import { SessionStorageService } from '@shared/services/storage.service';
import { IAccount } from '@shared/services/user.service';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
	selector: 'app-configuratorpoc',
	templateUrl: './configuratorpoc.component.html',
	styleUrls: ['./configuratorpoc.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ConfiguratorPocComponent implements OnInit, OnDestroy {
	form: FormGroup;
	model = new FormControl<string>('');
	width = new FormControl<number>(0);
	height = new FormControl<number>(0);
	queryParams = '';
	user = '';
	orderNumber = '';
	engine = '';

	private destroyNotifier = new Subject<void>();

	constructor(
		private salesService: SalesService,
		private snackBar: MatSnackBar,
		private route: ActivatedRoute,
		private sessionStorageService: SessionStorageService,
	) {
		this.form = new FormGroup<any>({
			model: this.model,
			width: this.width,
			height: this.height,
		});

		const account = this.sessionStorageService.get('User.Account');
		const acc: IAccount = JSON.parse(account);
		if (acc != null) {
			this.engine = acc.defaultEngine;
		}
	}

	ngOnInit(): void {
		this.route.queryParams.pipe(takeUntil(this.destroyNotifier)).subscribe((params) => {
			this.queryParams = JSON.stringify(params);
			if ('orderNumber' in params) {
				this.orderNumber = params['orderNumber'];
			}
		});
		this.user = this.sessionStorageService.get('User.Email');
	}

	ngOnDestroy(): void {
		this.destroyNotifier.next();
		this.destroyNotifier.complete();
	}

	calculateModel() {
		const bomParams: IBOMParameters = {
			Model: this.model.value,
			Width: this.width.value,
			Height: this.height.value,
		};
		this.salesService
			.calculatePosition(bomParams, this.engine, this.orderNumber)
			.pipe(take(1))
			.subscribe((v) => {
				this.snackBar.open(`Id: ${v.result.id}`, `Status: ${v.result.status} Price: ${v.result.bom?.listPrice}`, { duration: 5000 });
			});
	}
}
